<template>
  <el-table-column
    prop="is_billable"
    sortable="custom"
    label="Számlázandó"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      <el-tag type="success" v-if="scope.row.is_billable" size="small">Igen</el-tag>
      <el-tag type="danger" v-if="!scope.row.is_billable" size="small">Nem</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_billable',
  };
</script>
